import { Box, Dialog, Grid, IconButton, Skeleton, Theme, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { ReportsRightLayout } from '../../InvestorReport/index';
import { MFSubmitButton } from '../../../lib/formik';
import { useEffect, useState } from 'react';
import * as Yup from 'yup';
import dayjs from "dayjs";
import { DayJsDatePicker } from '../../onboarding/newDatePicker';
import { reportDownload } from '../../Reports/report-utils';
import { getHoldingReport, getReportsInvestorList } from '../../../redux-store/actions/reports';
import { RootStateType } from '../../../redux-store/reducers';
import { CONTENT_TYPE, USER_ROLES } from '../../../utils/constant';
import FormikSearchDropdown from '../../../lib/formik/FormikSearchDropdown';
import { ReportsListObj, ReportsListRes, ReportsPortfolioObj } from '../../../redux-store/types/api-types';
import { maskInfo } from '../../../utils/utilityFunctions';
import { DialogCloseIcon, YellowWarning } from '../../../assets/SvgIcons';
import MFSelectField from '../../../lib/formik/SelectField';


// const downloadOptions = [
//     { key: 'PDF', value: 'pdf' },
//     { key: 'Excel', value: 'excel' },
// ]


interface Values {
    selectedInvestor?: ReportsListObj | null;
    downloadOption: string;
    selectedInvestorPortfolio?: ReportsPortfolioObj | null;
    date: string
}

export function HoldingReport({
    handleSideSectionDisabled
}: {
    handleSideSectionDisabled: (value: boolean) => void
}): JSX.Element {
    const { enqueueSnackbar } = useSnackbar();
    const currentDate = dayjs();
    const dispatch = useDispatch();
    const [isDownloading, setIsDownloading] = useState<boolean>(false);
    const { isNavbarInfoLoading, businessDate } = useSelector((state: RootStateType) => state.navbarInfo);
    const [loading, setLoading] = useState<boolean>(false);
    const { iwappRmId, investorClientId = '' } = useSelector((state: RootStateType) => state.id);
    const { role = '' } = useSelector((state: RootStateType) => state.auth);

    const [investorListData, setInvestorListData] = useState<ReportsListRes>({} as ReportsListRes);
    const [isNoInvestorDialogVisible, setNoInvestorDialogVisible] = useState<boolean>(false)


    const todayDate = new Date();
    const formattedBusinessDate = businessDate?.length ? dayjs(businessDate, "DD/MM/YYYY").format("YYYY-MM-DD") : dayjs(todayDate).format("YYYY-MM-DD");

    const holdingReportValidation = Yup.object().shape({
        ...(role === USER_ROLES.RM
            ?
            {
                selectedInvestor: Yup
                    .object()
                    .nullable()
                    .test(
                        "investor-required",
                        "Please select an investor",
                        function (value) { return !!value }
                    ),
                // selectedInvestorPortfolio: Yup
                //     .object()
                //     .nullable()
                //     .test(
                //         "investor-portfolio-required",
                //         "Please select an investor portfolio",
                //         function (value) { return !!value }
                //     )
            }
            : {}
        ),
        // downloadOption: Yup.string().required('Please select download option'),
        date: Yup
            .date()
            .required('Date is required')
            .typeError('Date is required')
            .min(dayjs("1950-01-01").format("YYYY-MM-DD"), "Date should not be less than 01/01/1950")
            .max(formattedBusinessDate, "Date should not be greater than system's date")
    });

    const handleSubmit = async ({ selectedInvestor, date, selectedInvestorPortfolio, downloadOption }: { selectedInvestor?: ReportsListObj | null, date: string, selectedInvestorPortfolio?: ReportsPortfolioObj | null, downloadOption: string }) => {
        try {
            setIsDownloading(true)
            handleSideSectionDisabled(true)
            const payload = {
                clientCode: role === USER_ROLES.RM ? `${selectedInvestor?.clientCode ?? ""}` : `${investorClientId}`,
                end: dayjs(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
                // isPDF: (downloadOption ?? "").toLowerCase() === 'pdf' ? true : false,
                isPDF:true
            }
            const response = await (dispatch(getHoldingReport(payload)) as unknown as Promise<any>)
            if (response.type) {
                enqueueSnackbar('File downloaded successfully.', {
                    variant: 'success',
                    autoHideDuration: 2000,
                });
                reportDownload(response as unknown as Blob, `HoldingReport.${response.type === CONTENT_TYPE.PDF ? 'pdf' : 'xlsx'}`);
            } else {
                enqueueSnackbar('File download failed!.', {
                    variant: 'error',
                    autoHideDuration: 2000,
                });
            }

        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setIsDownloading(false)
            handleSideSectionDisabled(false)
        }
    }

    const fetchInvestorList = async () => {
        let response = {} as ReportsListRes

        // if ([USER_ROLES.ANALYST].includes(role)) {
        //     response = await (dispatch(getReportsAnalystInvestorList({
        //         analystId: `${iwappRmId}`
        //     })) as unknown as Promise<ReportsListRes>);
        // } else {
        response = await (dispatch(getReportsInvestorList({
            rmId: `${iwappRmId}`
        })) as unknown as Promise<ReportsListRes>);
        // }

        setInvestorListData(response);
        if (!response?.isSuccess) {
            setNoInvestorDialogVisible(true)
        }
    };

    const handleNoInvestorDialogClose = () => {
        setNoInvestorDialogVisible(false)
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                await fetchInvestorList();
            } catch (e) {
                console.log("Error: ", e)
            } finally {
                setLoading(false);
            }
        }
        role === USER_ROLES.RM && fetchData();
    }, []);

    // const handleInvestorPortfolioChange = (selectedObj: Record<string, any>) => {
    //     if (!formikRef.current) return;

    //     const { values, setValues } = formikRef.current ?? {};

    //     if (!selectedObj) {
    //         setValues({
    //             ...values,
    //             selectedInvestorPortfolio: null
    //         })
    //     }

    //     setValues({
    //         ...values,
    //         selectedInvestorPortfolio: selectedObj as ReportsPortfolioObj,
    //     })
    // }

    const InitialValues: Values = {
        ...(role === USER_ROLES.RM ? { selectedInvestor: null, selectedInvestorPortfolio: null } : {}),
        downloadOption: '',
        date: formattedBusinessDate
    }

    return (
        <>
            <ReportsRightLayout>
                <Typography
                    variant='h2'
                    sx={{
                        color: 'text.primary',
                        lineHeight: '25px',
                        letterSpacing: '0.01px',
                        mb: '40px'
                    }}
                >
                    Holding Report
                </Typography>
                <Formik
                    // innerRef={formikRef}
                    validationSchema={holdingReportValidation}
                    initialValues={InitialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize={true}
                >
                    {({ values, setValues, setFieldValue }) => (
                        <Form>
                            <Grid container rowSpacing={3} >
                                <Grid item container columnSpacing={3}>
                                    {role === USER_ROLES.RM
                                        &&
                                        <Grid item xs={12} lg={6}>
                                            {(loading || isNavbarInfoLoading) && <Skeleton
                                                animation={'wave'}
                                                height={90}

                                            />}
                                            {(!loading && !isNavbarInfoLoading) && (
                                                <FormikSearchDropdown
                                                    name='selectedInvestor'
                                                    label='Select Investor *'
                                                    options={(investorListData?.result ?? [])?.map((obj: ReportsListObj) => ({
                                                        ...obj,
                                                        label: `${maskInfo(obj.customerName)} (${obj?.clientCode ?? ""})`,
                                                        value: obj.clientCode
                                                    }))}
                                                    onChange={(selectedObj: Record<string, any>) => {
                                                        setValues({
                                                            ...values,
                                                            selectedInvestor: selectedObj as ReportsListObj,
                                                            selectedInvestorPortfolio: null
                                                        })
                                                    }}
                                                    disabled={
                                                        loading || isDownloading || isNavbarInfoLoading

                                                    }
                                                />
                                            )}
                                        </Grid>
                                    }
                                    {/* {role === USER_ROLES.RM && (
                                        <Grid item xs={12} lg={6}>
                                            {(loading || isNavbarInfoLoading) && <Skeleton
                                                animation={'wave'}
                                                height={90}

                                            />}
                                            {(!loading && !isNavbarInfoLoading) && (
                                                <FormikSearchDropdown
                                                    name='selectedInvestorPortfolio'
                                                    label='Select Investor Portfolio *'
                                                    options={(values?.selectedInvestor?.portfolioList ?? [])?.map((obj: ReportsPortfolioObj) => ({
                                                        ...obj,
                                                        label: `${maskInfo(obj.portfolioName)} (${obj?.portfolioId ?? ""}) ${obj?.cusAccountType ? " - " + obj.cusAccountType : ""}`,
                                                        value: obj.portfolioId
                                                    }))}
                                                    onChange={(selectedObj: Record<string, any>) => {
                                                        setValues({
                                                            ...values,
                                                            selectedInvestorPortfolio: selectedObj as ReportsPortfolioObj
                                                        })
                                                    }}
                                                    disabled={loading || isDownloading || isNavbarInfoLoading || !values?.selectedInvestor}
                                                />
                                            )}
                                        </Grid>
                                    )} */}
                                    <Grid item xs={12} lg={6}>
                                        {isNavbarInfoLoading && <Skeleton
                                            animation={'wave'}
                                            height={90}

                                        />}
                                        {!isNavbarInfoLoading && <DayJsDatePicker
                                            id=""
                                            name='date'
                                            label="Select Date *"
                                            maxDate={new Date()}
                                            disabled={isDownloading || isNavbarInfoLoading}
                                            currentDate={formattedBusinessDate}
                                        />}
                                    </Grid>
                                    {/* <Grid item xs={12} lg={6}>
                                        {(loading || isNavbarInfoLoading) && <Skeleton
                                            animation={'wave'}
                                            height={90}

                                        />}
                                        {(!loading && !isNavbarInfoLoading) &&
                                            <MFSelectField
                                                name={'downloadOption'}
                                                label="Select Download Option"
                                                items={downloadOptions}
                                                value={values.downloadOption}
                                                onChange={(e) => {
                                                    setFieldValue('downloadOption', e.target.value);
                                                }}
                                                disabled={isDownloading}
                                            />}
                                    </Grid> */}

                                </Grid>
                                <Grid item container columnSpacing={3} justifyContent={'flex-end'}>
                                    <Grid item xs={12} lg={6}>
                                        {isNavbarInfoLoading && <Skeleton
                                            animation={'wave'}
                                            height={90}

                                        />}
                                        {!isNavbarInfoLoading && <MFSubmitButton
                                            label="Download"
                                            loadingEnable={isDownloading}
                                        />}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>

            </ReportsRightLayout>
            <Dialog
                onClose={handleNoInvestorDialogClose}
                open={isNoInvestorDialogVisible}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "22px 24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "8px",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                columnGap: "12px",
                                alignItems: "center"
                            }}
                        >
                            <YellowWarning />
                            <Typography
                                variant="h2"
                                sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
                            >
                                No Investor Found!!
                            </Typography>
                        </Box>
                        <IconButton
                            aria-label="close"
                            onClick={handleNoInvestorDialogClose}
                            sx={{
                                padding: "5px"
                            }}
                        >
                            <DialogCloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </Dialog>
        </>
    );
};

